import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/client/Services/RemodelingPage/RemodelingPage.tsx");
